module.exports = "<div class=\"clearfix\"></div>\n<dynamic-html-outlet [src]=\"content\"></dynamic-html-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.html
// module id = 556
// module chunks = 0